import { FC, useMemo, useState, useEffect } from 'react';
import { Container, Field, FullLine } from './DealerDefaultText.styles';
import { Button, Section, Dropdown, Message, Loading } from '../../../../components';
import { SaveOutlined } from '@mui/icons-material';
import { Option } from '../../../../components/dropdown/Dropdown';
import { useToastStore, useUserStore } from '../../../../stores';
import { Form, SectionTitle, Separator } from '../../MyAccount.styles';
import { DealerDefaultTextDTO, fetchTextoPadrao, getAllAdminDealers, getDealerById, putDealerDefaultText, putDealerDefaultTextv2 } from '../../../../services';
import { fetchCompanies } from '../../../../module/company/repository/ComapnyRepository';

const DealerDefaultText: FC = () => {
	const { user } = useUserStore();
	const { setToast } = useToastStore();
	const [defaultText, setdefaultText] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const [concessionarias, setConcessionarias] = useState<Option[]>([]);

	const dealerOptions = useMemo(
		() =>
			(concessionarias?.map((item) => ({ value: item.value, label: item.label || '' })) || []).sort((a, b) =>
			  a.label.localeCompare(b.label)
			),
		  [concessionarias]
	);

	const [selectedOption, setSelectedOption] = useState<Option>(
		dealerOptions.length > 0
			? dealerOptions[0]
			: { value: 0, label: 'Nenhuma concessionária relacionada' }
	);

	const handleSelectOption = (option: Option) => {
		setSelectedOption(option);
	};



const handleUpdateDefaultText = async () => {
	try {
		const userId = user?.id;
		setLoading(true);
		if (userId) {
		const payload :DealerDefaultTextDTO = {
		id_concessionaria: Number(selectedOption.value),
		id_usuario: userId,
		texto_padrao: defaultText,
		}
	const result = await putDealerDefaultTextv2(payload);
	if (!result.success) {
		setToast({ message: result.message, variant: 'error' });
	}
	setToast({ message: result.message, variant: 'success' });
	};
	} catch (error) {
		setToast({ message: 'Erro. Contate o Administrador.', variant: 'error' });
	} finally {
		setLoading(false);
	}
}


	useEffect(() => {
		setLoading(true);

		const fetchData = async () => {
			try {
				const userId = user?.id;
				const result = await fetchTextoPadrao(userId!, Number(selectedOption.value));
				if (result.success) {
					setdefaultText(result.data);
				}
			} catch {
				setToast({ message: 'Erro ao buscar dados!', variant: 'error' });
			}
		};

		fetchData().finally(() => setLoading(false));
	}, [selectedOption, setToast, user]);

useEffect(() => {
	window.scrollTo(0, 0);

	const fetchConcessionarias = async () => {
		if (!user) return;

		const result = await fetchCompanies(user.id);

		if (result?.success && Array.isArray(result.data)) {
			const newOptions: Option[] = result.data.map((c: any) => ({
				value: c.id,
				label: c.label,
			}));

			setConcessionarias(newOptions);
		}
	};

	fetchConcessionarias();
}, [user]);

	if (loading) return <Loading fullScreen />;

	return (
		<Container>
			<Section>
				<SectionTitle>Concessionárias - Texto Padrão</SectionTitle>
				<Separator />
				<Form>
					<FullLine>
						<Field>
							<Dropdown
								options={dealerOptions}
								selected={selectedOption}
								onSelect={handleSelectOption}
							/>
						</Field>
					</FullLine>
					<Message
						value={defaultText}
						name='texto-padrao'
						label='Texto Padrão para anúncios'
						placeholder='Escreva o texto padrão aqui'
						onChange={(e) => setdefaultText(e.target.value)}
					/>
					<Button
						variant='contained'
						onClick={handleUpdateDefaultText}
						fitContent
						disabled={!selectedOption}
					>
						<SaveOutlined fontSize='medium' />
						<span>Salvar</span>
					</Button>
				</Form>
			</Section>
		</Container>
	);
};

export default DealerDefaultText;
